import { useNavigate, useParams } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import GameMatch from './GameMatch';
import AdminMessageInbox from './AdminMessageInbox';
import AdminMatchRequestInbox from './AdminMatchRequestInbox';
import '../css/GameMatchControlPage.css';

function GameMatchControlPage() {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const selectedGroupId = Number(groupId);

  return (
    <main className="gmc-page admin-shell-with-sidebar">
      <AdminSidebar active="game-control" groupId={selectedGroupId} />
      <AdminMessageInbox groupId={selectedGroupId} />
      <AdminMatchRequestInbox groupId={selectedGroupId} />
      <header className="gmc-header">
        <div>
          <button type="button" onClick={() => navigate('/dashboard')}>← Dashboard</button>
          <p>GAME MATCH CONTROL</p>
          <h1>จัด Match และควบคุมสนาม</h1>
        </div>
        <span>Group #{selectedGroupId}</span>
      </header>
      <section className="gmc-content"><GameMatch groupId={selectedGroupId} /></section>
    </main>
  );
}

export default GameMatchControlPage;
